// extracted by mini-css-extract-plugin
module.exports = {"reason":"RelistDetailsSection_reason__REGh3","container":"RelistDetailsSection_container__cNId0"};